import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לקרוא לזה בשם: “אני מתכווץ כדי שלא יעזבו”",
    opening: localizedGenderNode(
      [
      "היום אני לא מאשים את עצמי. אני מזהה דפוס: אני נהיה קטן כדי להישאר."
    ],
      [
      "היום אני לא מאשים את עצמי. אני מזהה דפוס: אני נהיה קטן כדי להישאר."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית.",
      "אני אומר לעצמי בלב: “הפחד הזה מנסה להגן עליי.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית.",
      "אני אומר לעצמי בלב: “הפחד הזה מנסה להגן עליי.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל את עצמי:\nמה אני עושה כדי “להיות בסדר” בעיני בן/בת הזוג?\n[כאן אני כותב]",
      "אני שואל את עצמי:\nאיפה אני לא מרשה לעצמי להיות אני?\n[כאן אני כותב]",
      "אני שואל את עצמי:\nמה הפחד אומר לי שיקרה אם אהיה אמיתי/ת?\n[כאן אני כותב]"
    ],
      [
      "אני שואל את עצמי:\nמה אני עושה כדי “להיות בסדר” בעיני בן/בת הזוג?\n[כאן אני כותב]",
      "אני שואל את עצמי:\nאיפה אני לא מרשה לעצמי להיות אני?\n[כאן אני כותב]",
      "אני שואל את עצמי:\nמה הפחד אומר לי שיקרה אם אהיה אמיתי/ת?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "היום אני רואה את הדפוס — בלי להילחם בו."
    ],
      [
      "סגירה",
      "היום אני רואה את הדפוס — בלי להילחם בו."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום: נשימה + משפט בלב: “אני יכול להיות אני, גם קצת.”",
      "פעם אחת היום: נשימה + משפט בלב: “אני יכול להיות אני, גם קצת.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "סיפור מול עובדה: מה באמת הסכנה?",
    opening: localizedGenderNode(
      [
      "היום אני מפריד בין פחד ישן לבין מה שקורה עכשיו."
    ],
      [
      "היום אני מפריד בין פחד ישן לבין מה שקורה עכשיו."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “לא כל פחד הוא עובדה.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “לא כל פחד הוא עובדה.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה העובדה היבשה? (מה באמת קרה, בלי פרשנות)\n[כאן אני כותב]",
      "איזה סיפור הראש שלי מספר? (“אם אגיד… יעזבו אותי”)\n[כאן אני כותב]",
      "מה זה עושה לי בגוף כשאני מאמין/ה לסיפור — ואיזו אמת עדינה אחת אני יכול/ה לבחור היום?\n[כאן אני כותב]"
    ],
      [
      "מה העובדה היבשה? (מה באמת קרה, בלי פרשנות)\n[כאן אני כותב]",
      "איזה סיפור הראש שלי מספר? (“אם אגיד… יעזבו אותי”)\n[כאן אני כותב]",
      "מה זה עושה לי בגוף כשאני מאמין/ה לסיפור — ואיזו אמת עדינה אחת אני יכול/ה לבחור היום?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "לא כל מחשבה היא אמת. לפעמים זה רק פחד שמבקש ביטחון."
    ],
      [
      "סגירה",
      "לא כל מחשבה היא אמת. לפעמים זה רק פחד שמבקש ביטחון."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום: “זה סיפור, לא עובדה.” + נשימה.",
      "פעם אחת היום: “זה סיפור, לא עובדה.” + נשימה."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "הדחף לרצות (פרוטוקול 90 שניות)",
    opening: localizedGenderNode(
      [
      "היום אני בונה עצירה לפני “ריצוי”."
    ],
      [
      "היום אני בונה עצירה לפני “ריצוי”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני בוחר/ת בי קודם.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני בוחר/ת בי קודם.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה אני מרצה הכי הרבה? (שתיקה/הסכמה/התנצלות/ויתור)\n[כאן אני כותב]",
      "מה אני מנסה למנוע דרך הריצוי? (כעס/נטישה/ביקורת/מרחק)\n[כאן אני כותב]",
      "פרוטוקול 90 שניות (קבוע מהיום)\n\n1. 3 נשימות איטיות\n\n2. לשים לב לגוף: איפה הפחד יושב\n\n3. משפט בלב: “זה פחד. הוא יעבור.”\nואז לבחור חלופה אחת קטנה.\n\n\nאיזו חלופה אחת אני בוחר/ת היום במקום לרצות?\n[כאן אני כותב]"
    ],
      [
      "איפה אני מרצה הכי הרבה? (שתיקה/הסכמה/התנצלות/ויתור)\n[כאן אני כותב]",
      "מה אני מנסה למנוע דרך הריצוי? (כעס/נטישה/ביקורת/מרחק)\n[כאן אני כותב]",
      "פרוטוקול 90 שניות (קבוע מהיום)\n\n1. 3 נשימות איטיות\n\n2. לשים לב לגוף: איפה הפחד יושב\n\n3. משפט בלב: “זה פחד. הוא יעבור.”\nואז לבחור חלופה אחת קטנה.\n\n\nאיזו חלופה אחת אני בוחר/ת היום במקום לרצות?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא רוצה/ת לרצות כדי להיות אהוב/ה."
    ],
      [
      "סגירה",
      "אני לא רוצה/ת לרצות כדי להיות אהוב/ה."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום — פרוטוקול 90 שניות לפני “כן” אוטומטי.",
      "פעם אחת היום — פרוטוקול 90 שניות לפני “כן” אוטומטי."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "איפה אני נעלם/ת בקשר",
    opening: localizedGenderNode(
      [
      "היום אני רואה איפה אני מוותר/ת על עצמי כדי לשמור קשר."
    ],
      [
      "היום אני רואה איפה אני מוותר/ת על עצמי כדי לשמור קשר."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “החיים שלי לא אמורים להצטמצם כדי להיות ביחד.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “החיים שלי לא אמורים להצטמצם כדי להיות ביחד.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה אני מרגיש/ה שאני “על תנאי”?\n[כאן אני כותב]",
      "איזה חלק בי אני מחביא/ה? (רצון/כאב/דעה/גבול)\n[כאן אני כותב]",
      "מה המחיר שאני משלם/ת על ההסתרה הזאת?\n[כאן אני כותב]"
    ],
      [
      "איפה אני מרגיש/ה שאני “על תנאי”?\n[כאן אני כותב]",
      "איזה חלק בי אני מחביא/ה? (רצון/כאב/דעה/גבול)\n[כאן אני כותב]",
      "מה המחיר שאני משלם/ת על ההסתרה הזאת?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אם אני נעלם/ת — הקשר לא באמת מחזיק אותי."
    ],
      [
      "סגירה",
      "אם אני נעלם/ת — הקשר לא באמת מחזיק אותי."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת משפט אחד של אמת עליי — לעצמי בלבד.",
      "אני כותב/ת משפט אחד של אמת עליי — לעצמי בלבד."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הבושה: “אם יראו אותי — לא ירצו”",
    opening: localizedGenderNode(
      [
      "היום אני נוגע בבושה בלי לתת לה לשלוט."
    ],
      [
      "היום אני נוגע בבושה בלי לתת לה לשלוט."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “בושה רוצה שאסתתר. היום אני נשאר/ת.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “בושה רוצה שאסתתר. היום אני נשאר/ת.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה המשפט הכי קשה שעולה בי על עצמי?\n[כאן אני כותב]",
      "אם חבר אהוב היה אומר את זה על עצמו — מה הייתי אומר לו?\n[כאן אני כותב]",
      "מה משפט רך אחד שאני מוכן/ה להגיד לעצמי היום?\n[כאן אני כותב]"
    ],
      [
      "מה המשפט הכי קשה שעולה בי על עצמי?\n[כאן אני כותב]",
      "אם חבר אהוב היה אומר את זה על עצמו — מה הייתי אומר לו?\n[כאן אני כותב]",
      "מה משפט רך אחד שאני מוכן/ה להגיד לעצמי היום?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "בושה לא אומרת אמת. היא אומרת שכואב לי להיות חשוף/ה."
    ],
      [
      "סגירה",
      "בושה לא אומרת אמת. היא אומרת שכואב לי להיות חשוף/ה."
    ]
    ),
    action: localizedGenderNode(
      "יד על חזה/בטן (אם נעים) + משפט רך אחד בלבד.",
      "יד על חזה/בטן (אם נעים) + משפט רך אחד בלבד."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "מאיפה זה בא (שורש עדין)",
    opening: localizedGenderNode(
      [
      "היום אני מבין/ה: הפחד לא התחיל בקשר הזה."
    ],
      [
      "היום אני מבין/ה: הפחד לא התחיל בקשר הזה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “זה דפוס ישן שמופעל עכשיו.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “זה דפוס ישן שמופעל עכשיו.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי בחיים למדתי שלהיות אני מסוכן?\n[כאן אני כותב]",
      "מה הייתי בוחר/ת/ה אז ולא קיבלתי?\n[כאן אני כותב]",
      "מה אני בוחר/ת/ה היום כדי להרגיש בטוח/ה להביא את עצמי?\n[כאן אני כותב]"
    ],
      [
      "מתי בחיים למדתי שלהיות אני מסוכן?\n[כאן אני כותב]",
      "מה הייתי בוחר/ת/ה אז ולא קיבלתי?\n[כאן אני כותב]",
      "מה אני בוחר/ת/ה היום כדי להרגיש בטוח/ה להביא את עצמי?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא אשם בזה שנוצר בי פחד. אבל אני יכול לטפל בו."
    ],
      [
      "סגירה",
      "אני לא אשם בזה שנוצר בי פחד. אבל אני יכול לטפל בו."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת: “היום אני מבוגר/ת. אני יכול/ה להגן עליי.”",
      "אני כותב/ת: “היום אני מבוגר/ת. אני יכול/ה להגן עליי.”"
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "אמת קטנה (חשיפה נקייה)",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת להביא אמת קטנה בלי להציף."
    ],
      [
      "היום אני מתרגל/ת להביא אמת קטנה בלי להציף."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “לא בוחר/ת הכול. רק משהו אחד קטן ואמיתי.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “לא בוחר/ת הכול. רק משהו אחד קטן ואמיתי.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזו אמת קטנה אני מסתיר/ה בדרך כלל?\n[כאן אני כותב]",
      "מה הפחד שלי אם אגיד אותה?\n[כאן אני כותב]",
      "איך אפשר לומר אותה בצורה רכה וברורה? (משפט אחד)\n[כאן אני כותב]"
    ],
      [
      "איזו אמת קטנה אני מסתיר/ה בדרך כלל?\n[כאן אני כותב]",
      "מה הפחד שלי אם אגיד אותה?\n[כאן אני כותב]",
      "איך אפשר לומר אותה בצורה רכה וברורה? (משפט אחד)\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אומץ הוא לא דרמה. אומץ הוא משפט אחד."
    ],
      [
      "סגירה",
      "אומץ הוא לא דרמה. אומץ הוא משפט אחד."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת לעצמי משפט “אמת קטנה” ומתרגל/ת להגיד אותו בקול (לבד).",
      "אני כותב/ת לעצמי משפט “אמת קטנה” ומתרגל/ת להגיד אותו בקול (לבד)."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "גבול רך אחד (בלי התנצלות יתר)",
    opening: localizedGenderNode(
      [
      "היום אני שם גבול קטן שמגן עליי."
    ],
      [
      "היום אני שם גבול קטן שמגן עליי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “גבול הוא שמירה, לא איום.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “גבול הוא שמירה, לא איום.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה גבול אחד חסר לי בקשר?\n[כאן אני כותב]",
      "מה הפחד שלי אם אשים אותו?\n[כאן אני כותב]",
      "מה תשובה רכה לפחד הזה — ואיך אני מנסח/ת את הגבול בגוף ראשון?\n[כאן אני כותב]"
    ],
      [
      "איזה גבול אחד חסר לי בקשר?\n[כאן אני כותב]",
      "מה הפחד שלי אם אשים אותו?\n[כאן אני כותב]",
      "מה תשובה רכה לפחד הזה — ואיך אני מנסח/ת את הגבול בגוף ראשון?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "מי שאוהב אותי — בוחר/ת לפגוש אותי, לא גרסה מוקטנת שלי."
    ],
      [
      "סגירה",
      "מי שאוהב אותי — בוחר/ת לפגוש אותי, לא גרסה מוקטנת שלי."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר/ת גבול אחד קטן לשבוע, גם אם רק בתוכי.",
      "אני בוחר/ת גבול אחד קטן לשבוע, גם אם רק בתוכי."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "לא לבקש “רשות להיות”",
    opening: localizedGenderNode(
      [
      "היום אני מפסיק/ה לחכות לאישור כדי להרגיש לגיטימי/ת."
    ],
      [
      "היום אני מפסיק/ה לחכות לאישור כדי להרגיש לגיטימי/ת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “הקיום שלי לא בוחר/ת אישור.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “הקיום שלי לא בוחר/ת אישור.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה אני מחפש/ת אישור בסיסי?\n[כאן אני כותב]",
      "מה אני עושה כשאני לא מקבל/ת אותו?\n[כאן אני כותב]",
      "איזו רשות אני נותן/ת לעצמי היום? (משפט אחד)\n[כאן אני כותב]"
    ],
      [
      "איפה אני מחפש/ת אישור בסיסי?\n[כאן אני כותב]",
      "מה אני עושה כשאני לא מקבל/ת אותו?\n[כאן אני כותב]",
      "איזו רשות אני נותן/ת לעצמי היום? (משפט אחד)\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני יכול/ה להיות אני גם כשאין תגובה מושלמת."
    ],
      [
      "סגירה",
      "אני יכול/ה להיות אני גם כשאין תגובה מושלמת."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום: אני עושה משהו קטן “בשבילי” בלי להסביר.",
      "פעם אחת היום: אני עושה משהו קטן “בשבילי” בלי להסביר."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "פחד נטישה בזמן קונפליקט",
    opening: localizedGenderNode(
      [
      "היום אני לומד/ת להישאר יציב/ה כשיש מתח."
    ],
      [
      "היום אני לומד/ת להישאר יציב/ה כשיש מתח."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “קונפליקט לא תמיד אומר נטישה.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “קונפליקט לא תמיד אומר נטישה.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה קורה לי בגוף כשיש מתח?\n[כאן אני כותב]",
      "מה אני עושה כדי להרגיע מיד? (לרצות/לשתוק/לתקוף)\n[כאן אני כותב]",
      "איזה משפט ביטחון אני יכול/ה להגיד לעצמי באמצע מתח?\n[כאן אני כותב]"
    ],
      [
      "מה קורה לי בגוף כשיש מתח?\n[כאן אני כותב]",
      "מה אני עושה כדי להרגיע מיד? (לרצות/לשתוק/לתקוף)\n[כאן אני כותב]",
      "איזה משפט ביטחון אני יכול/ה להגיד לעצמי באמצע מתח?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני יכול/ה להחזיק מתח בלי להיעלם."
    ],
      [
      "סגירה",
      "אני יכול/ה להחזיק מתח בלי להיעלם."
    ]
    ),
    action: localizedGenderNode(
      "במיני-מתח אחד היום: נשימה + משפט הביטחון שלי.",
      "במיני-מתח אחד היום: נשימה + משפט הביטחון שלי."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "מה אני בוחר/ה כדי להרגיש בטוח/ה בקשר",
    opening: localizedGenderNode(
      [
      "היום אני מכיר/ה בצרכים שלי בלי להתבייש."
    ],
      [
      "היום אני מכיר/ה בצרכים שלי בלי להתבייש."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “צורך הוא לא חולשה.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “צורך הוא לא חולשה.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה 3 צרכים בסיסיים שלי בקשר?\n[כאן אני כותב]",
      "איזה צורך אני הכי מפחד/ת לבקש?\n[כאן אני כותב]",
      "מה דרך אחת לבקש אותו בפשטות?\n[כאן אני כותב]"
    ],
      [
      "מה 3 צרכים בסיסיים שלי בקשר?\n[כאן אני כותב]",
      "איזה צורך אני הכי מפחד/ת לבקש?\n[כאן אני כותב]",
      "מה דרך אחת לבקש אותו בפשטות?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אם אני לא יודע/ת מה אני בוחר/ת/ה — אני תמיד אהיה “על תנאי”."
    ],
      [
      "סגירה",
      "אם אני לא יודע/ת מה אני בוחר/ת/ה — אני תמיד אהיה “על תנאי”."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת בקשה אחת קצרה שאני מוכן/ה לומר (אפילו עוד לא אומר/ת).",
      "אני כותב/ת בקשה אחת קצרה שאני מוכן/ה לומר (אפילו עוד לא אומר/ת)."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "“אם זה ייגמר, אני עדיין נשאר איתי”",
    opening: localizedGenderNode(
      [
      "היום אני מחזק/ת את העוגן הפנימי שלי."
    ],
      [
      "היום אני מחזק/ת את העוגן הפנימי שלי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני לא נעלם אם קשר נגמר.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני לא נעלם אם קשר נגמר.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הכי מפחיד אותי בסיום קשר?\n[כאן אני כותב]",
      "אילו משאבים יש לי (או אני יכול לבנות) אם זה יקרה?\n[כאן אני כותב]",
      "איזה משפט חזרה אני רוצה לימים קשים?\n[כאן אני כותב]"
    ],
      [
      "מה הכי מפחיד אותי בסיום קשר?\n[כאן אני כותב]",
      "אילו משאבים יש לי (או אני יכול לבנות) אם זה יקרה?\n[כאן אני כותב]",
      "איזה משפט חזרה אני רוצה לימים קשים?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "הביטחון שלי מתחיל בזה שאני נשאר עם עצמי."
    ],
      [
      "סגירה",
      "הביטחון שלי מתחיל בזה שאני נשאר עם עצמי."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר/ת “עוגן” אחד: שיחה עם אדם בטוח / הליכה / סדר קטן.",
      "אני בוחר/ת “עוגן” אחד: שיחה עם אדם בטוח / הליכה / סדר קטן."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "לבחור ערך מוביל (לא פחד מוביל)",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת לערך להוביל, לא לפחד."
    ],
      [
      "היום אני נותן/ת לערך להוביל, לא לפחד."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “פחד צועק. ערך מכוון.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “פחד צועק. ערך מכוון.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה ערך אני רוצה להביא לקשר? (כנות/כבוד/רוך/אמת/יציבות)\n[כאן אני כותב]",
      "מה נראה אחרת כשאני פועל/ת מהערך הזה?\n[כאן אני כותב]",
      "איזו פעולה קטנה השבוע תבטא את הערך הזה?\n[כאן אני כותב]"
    ],
      [
      "איזה ערך אני רוצה להביא לקשר? (כנות/כבוד/רוך/אמת/יציבות)\n[כאן אני כותב]",
      "מה נראה אחרת כשאני פועל/ת מהערך הזה?\n[כאן אני כותב]",
      "איזו פעולה קטנה השבוע תבטא את הערך הזה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא רוצה/ת לבנות קשר מתוך הישרדות."
    ],
      [
      "סגירה",
      "אני לא רוצה/ת לבנות קשר מתוך הישרדות."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת את הערך שלי ושם/ה אותו מול העיניים.",
      "אני כותב/ת את הערך שלי ושם/ה אותו מול העיניים."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה רכה: קשר שלא דורש ממני להיעלם",
    opening: localizedGenderNode(
      [
      "היום אני מסיים/ת מסע בלי דרמה — עם אמת."
    ],
      [
      "היום אני מסיים/ת מסע בלי דרמה — עם אמת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני חוזר/ת אליי.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני חוזר/ת אליי.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הבנתי על הדפוס שלי?\n[כאן אני כותב]",
      "מה נהיה ברור לי עכשיו, גם אם זה כואב?\n[כאן אני כותב]",
      "משפט חזרה לימים של פחד נטישה (קצר וברור):\n[כאן אני כותב]"
    ],
      [
      "מה הבנתי על הדפוס שלי?\n[כאן אני כותב]",
      "מה נהיה ברור לי עכשיו, גם אם זה כואב?\n[כאן אני כותב]",
      "משפט חזרה לימים של פחד נטישה (קצר וברור):\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה סופית למסע",
      "אני לא בוחר/ת/ה קשר שבו אני חי/ה על תנאי.",
      "אני לא בוחר/ת/ה להיעלם כדי שיאהבו אותי.",
      "אני ממשיך/ה ללכת —",
      "לאט, בשקט, עם עצמי.",
      "וזה כוח."
    ],
      [
      "סגירה סופית למסע",
      "אני לא בוחר/ת/ה קשר שבו אני חי/ה על תנאי.",
      "אני לא בוחר/ת/ה להיעלם כדי שיאהבו אותי.",
      "אני ממשיך/ה ללכת —",
      "לאט, בשקט, עם עצמי.",
      "וזה כוח."
    ]
    ),
    action: localizedGenderNode(
      "פעולה אחת שמסמלת “אני חוזר/ת לעצמי”: לסדר משהו קטן / הליכה במקום חדש / כתיבה של 5 שורות ביומן.",
      "פעולה אחת שמסמלת “אני חוזר/ת לעצמי”: לסדר משהו קטן / הליכה במקום חדש / כתיבה של 5 שורות ביומן."
    ),
  },
].map(buildNormalizedDay);

export const conditionalRelationshipFearOfAbandonmentBlueprintHe = buildNormalizedPilotBlueprint({
  id: "conditional_relationship_fear_of_abandonment_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "conditional_relationship_fear_of_abandonment",
  category: "general",
  journeyName: {
    he: "קשר שכל הזמן “על תנאי” (פחד שינטשו אותי אם אהיה אני)",
    en: "A Relationship That’s Always “Conditional” (Fear They’ll Leave If I’m Myself)",
    es: "Una relación siempre “condicional” (miedo a que me abandonen si soy yo)",
  },
  days,
});

export default conditionalRelationshipFearOfAbandonmentBlueprintHe;
